import { Location } from 'react-router-dom';
import { BASE_URL, DOMAIN_URL } from '../config';

export const buildQueryString = (params: Dict<string>) => new URLSearchParams(params).toString();

export const getUrl = (location: string | Location | undefined) =>
  location
    ? typeof location === 'string'
      ? location
      : `${location?.pathname}${location?.search}`
    : undefined;

export const fullUrl = (path: string) => `${BASE_URL}${path}`;
export const domainUrl = (path: string) => `${DOMAIN_URL}${path}`;

export const getUrlWithPath = () => window.location.href.split('?')[0];

export const https = 'https://';

export const trimHttps = (url: string) =>
  url.startsWith('http://')
    ? url.substring(7)
    : url.startsWith('https://')
      ? url.substring(8)
      : url;
